export const DaoTaoIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_55_825" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <g clipPath="url(#clip0_55_825)">
        <path
          opacity="0.4"
          d="M8.25 6.75C6.5955 6.75 5.25 8.0955 5.25 9.75C5.25 11.4045 6.5955 12.75 8.25 12.75C9.9045 12.75 11.25 11.4045 11.25 9.75C11.25 8.0955 9.9045 6.75 8.25 6.75ZM7.125 11.901V7.599L10.3523 9.75L7.125 11.901ZM20.25 1.5H3.75C2.0955 1.5 0.75 2.8455 0.75 4.5V15C0.75 16.6545 2.0955 18 3.75 18H20.25C21.9045 18 23.25 16.6545 23.25 15V4.5C23.25 2.8455 21.9045 1.5 20.25 1.5ZM8.25 14.25C5.76825 14.25 3.75 12.2318 3.75 9.75C3.75 7.26825 5.76825 5.25 8.25 5.25C10.7318 5.25 12.75 7.26825 12.75 9.75C12.75 12.2318 10.7318 14.25 8.25 14.25ZM20.25 13.5H14.25V12H20.25V13.5ZM20.25 10.5H14.25V9H20.25V10.5ZM20.25 7.5H14.25V6H20.25V7.5Z"
          fill="#0c68e9"
        />
        <path d="M14.25 21V19.5H9.75V21H6.75V22.5H17.25V21H14.25Z" fill="#0c68e9" />
        <path
          d="M8.25 6.75C6.5955 6.75 5.25 8.0955 5.25 9.75C5.25 11.4045 6.5955 12.75 8.25 12.75C9.9045 12.75 11.25 11.4045 11.25 9.75C11.25 8.0955 9.9045 6.75 8.25 6.75ZM7.125 11.901V7.599L10.3523 9.75L7.125 11.901ZM8.25 14.25C5.76825 14.25 3.75 12.2318 3.75 9.75C3.75 7.26825 5.76825 5.25 8.25 5.25C10.7318 5.25 12.75 7.26825 12.75 9.75C12.75 12.2318 10.7318 14.25 8.25 14.25ZM20.25 13.5H14.25V12H20.25V13.5ZM20.25 10.5H14.25V9H20.25V10.5ZM20.25 7.5H14.25V6H20.25V7.5Z"
          fill="#0c68e9"
        />
      </g>
    </mask>
    <g mask="url(#mask0_55_825)">
      <rect width="24" height="24" fill="#0c68e9" />
    </g>
    <defs>
      <clipPath id="clip0_55_825">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ExamIcon = () => (
  <svg width="24" height="24" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      fill="#0c68e9"
      d="M216,36H40A20,20,0,0,0,20,56V216a12,12,0,0,0,17.37,10.73L64,213.42l26.63,13.31a12,12,0,0,0,10.74,0L128,213.42l26.63,13.31a12,12,0,0,0,10.74,0L192,213.42l26.63,13.31A12,12,0,0,0,236,216V56A20,20,0,0,0,216,36Zm-4,160.58-14.63-7.31a12,12,0,0,0-10.74,0L160,202.58l-26.63-13.31a12,12,0,0,0-10.74,0L96,202.58,69.37,189.27a12,12,0,0,0-10.74,0L44,196.58V60H212ZM62.63,170.73a12,12,0,0,0,16.1-5.36L81.42,160h37.16l2.69,5.37a12,12,0,1,0,21.46-10.74l-32-64a12,12,0,0,0-21.46,0l-32,64A12,12,0,0,0,62.63,170.73ZM106.58,136H93.42L100,122.83ZM144,128a12,12,0,0,1,12-12h4v-4a12,12,0,0,1,24,0v4h4a12,12,0,0,1,0,24h-4v4a12,12,0,0,1-24,0v-4h-4A12,12,0,0,1,144,128Z"
    />
  </svg>
);
export const BangKeHoachIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_55_840" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <g clipPath="url(#clip0_55_840)">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.9114 8.22695C19.4717 8.5891 17.7718 8.61315 16.3035 8.1646C15.6828 7.97495 15.1988 7.4914 14.9893 6.8771C14.4674 5.34677 14.3385 3.47362 14.722 2.0318C13.9279 2.01186 13.0248 2 12 2C8.51575 2 6.43945 2.13682 5.26285 2.26379C4.39116 2.35785 3.71902 2.94826 3.5558 3.80967C3.30175 5.15055 3 7.65725 3 12C3 16.3428 3.30175 18.8494 3.5558 20.1903C3.71902 21.0518 4.39116 21.6422 5.26285 21.7362C6.43945 21.8631 8.51575 22 12 22C15.4843 22 17.5606 21.8631 18.7372 21.7362C19.6089 21.6422 20.281 21.0518 20.4442 20.1903C20.6982 18.8494 21 16.3428 21 12C21 10.5445 20.9661 9.2952 20.9114 8.22695ZM8 13C7.4477 13 7 12.5523 7 12C7 11.4477 7.4477 11 8 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H8ZM8 17.5C7.4477 17.5 7 17.0523 7 16.5C7 15.9477 7.4477 15.5 8 15.5H15C15.5523 15.5 16 15.9477 16 16.5C16 17.0523 15.5523 17.5 15 17.5H8Z"
          fill="#0c68e9"
        />
        <path
          d="M7 16.5C7 17.0523 7.4477 17.5 8 17.5H15C15.5523 17.5 16 17.0523 16 16.5C16 15.9477 15.5523 15.5 15 15.5H8C7.4477 15.5 7 15.9477 7 16.5Z"
          fill="#0c68e9"
        />
        <path
          d="M7 12C7 12.5523 7.4477 13 8 13H12C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11H8C7.4477 11 7 11.4477 7 12Z"
          fill="#0c68e9"
        />
        <path
          d="M20.9114 8.22695C19.4717 8.5891 17.7718 8.61315 16.3036 8.1646C15.6828 7.97495 15.1988 7.4914 14.9893 6.8771C14.4674 5.34675 14.3384 3.47357 14.722 2.03174C14.722 2.03174 15.9461 2.49994 18.1961 4.74994C20.4461 6.99995 20.9114 8.22695 20.9114 8.22695Z"
          fill="#0c68e9"
        />
      </g>
    </mask>
    <g mask="url(#mask0_55_840)">
      <rect width="24" height="24" fill="#0c68e9" />
    </g>
    <defs>
      <clipPath id="clip0_55_840">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const HopTuanIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_55_871" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <g clipPath="url(#clip0_55_871)">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.12411 8H21.8758C21.9467 9.20109 22 10.8266 22 13C22 16.4843 21.8631 18.5605 21.7362 19.7371C21.6422 20.6088 21.0518 21.281 20.1903 21.4442C18.8494 21.6983 16.3428 22 12 22C7.65725 22 5.15055 21.6983 3.80967 21.4442C2.94826 21.281 2.35785 20.6088 2.26379 19.7371C2.13682 18.5605 2 16.4843 2 13C2 10.8266 2.05324 9.20109 2.12411 8ZM6.5 12.6815C6.5 12.0806 6.93315 11.6082 7.5337 11.5868C8.3136 11.559 9.6669 11.5275 12 11.5069C14.5069 11.4848 15.8826 11.5197 16.6312 11.5599C17.1554 11.5881 17.5 11.9946 17.5 12.5196V12.9107C17.5 13.4726 17.1157 13.9093 16.5543 13.934C15.7898 13.9675 14.4235 14 12 14C9.5765 14 8.21025 13.9675 7.44565 13.934C6.88435 13.9093 6.5 13.4726 6.5 12.9107V12.6815ZM6.5 17.0891C6.5 16.5276 6.8844 16.0793 7.44515 16.0503C7.97275 16.0231 8.7795 16.0001 10 16.0001C11.2205 16.0001 12.0272 16.0231 12.5548 16.0503C13.1156 16.0793 13.5 16.5276 13.5 17.0891V17.4111C13.5 17.9726 13.1156 18.4208 12.5548 18.4498C12.0272 18.4771 11.2205 18.5001 10 18.5001C8.7795 18.5001 7.97275 18.4771 7.44515 18.4498C6.8844 18.4208 6.5 17.9726 6.5 17.4111V17.0891Z"
          fill="#0c68e9"
        />
        <path
          d="M17.915 2.03126C18.2276 2.05703 18.4424 2.28598 18.4636 2.59889C18.4831 2.88636 18.5 3.32917 18.5 4C18.5 4.10776 18.4995 4.20964 18.4987 4.30593C19.1999 4.38632 19.7561 4.47356 20.1902 4.55581C21.0516 4.71901 21.642 5.39115 21.7361 6.26285C21.7839 6.7055 21.833 7.27555 21.8758 8H2.12402C2.16677 7.27555 2.21593 6.7055 2.2637 6.26285C2.35776 5.39115 2.94817 4.71902 3.80958 4.55581C4.24369 4.47356 4.8 4.3863 5.50125 4.30591C5.50045 4.20962 5.5 4.10775 5.5 4C5.5 3.32917 5.5169 2.88636 5.5364 2.59889C5.5576 2.28598 5.7724 2.05703 6.08495 2.03126C6.29765 2.01372 6.5938 2 7 2C7.4062 2 7.70235 2.01372 7.91505 2.03126C8.2276 2.05703 8.4424 2.28598 8.4636 2.59889C8.4831 2.88636 8.5 3.32917 8.5 4C8.5 4.02539 8.5 4.05047 8.49995 4.07521C9.50645 4.02844 10.6666 4 11.9999 4C13.3332 4 14.4935 4.02845 15.5 4.07522V4C15.5 3.32917 15.5169 2.88636 15.5364 2.59889C15.5576 2.28598 15.7724 2.05703 16.0849 2.03126C16.2976 2.01372 16.5938 2 17 2C17.4062 2 17.7023 2.01372 17.915 2.03126Z"
          fill="#0c68e9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5337 11.5868C6.93315 11.6081 6.5 12.0805 6.5 12.6815V12.9107C6.5 13.4725 6.88435 13.9093 7.44565 13.9339C8.21025 13.9674 9.5765 14 12 14C14.4235 14 15.7897 13.9674 16.5543 13.9339C17.1156 13.9093 17.5 13.4725 17.5 12.9107V12.5196C17.5 11.9946 17.1554 11.5881 16.6312 11.5599C15.8825 11.5196 14.5069 11.4847 12 11.5069C9.6669 11.5274 8.3136 11.559 7.5337 11.5868ZM7.44515 16.0503C6.8844 16.0793 6.5 16.5275 6.5 17.089V17.411C6.5 17.9725 6.8844 18.4208 7.44515 18.4498C7.97275 18.477 8.7795 18.5 10 18.5C11.2205 18.5 12.0272 18.477 12.5548 18.4498C13.1156 18.4208 13.5 17.9725 13.5 17.411V17.089C13.5 16.5275 13.1156 16.0793 12.5548 16.0503C12.0272 16.023 11.2205 16 10 16C8.7795 16 7.97275 16.023 7.44515 16.0503Z"
          fill="#0c68e9"
        />
      </g>
    </mask>
    <g mask="url(#mask0_55_871)">
      <rect width="24" height="24" fill="#0c68e9" />
    </g>
    <defs>
      <clipPath id="clip0_55_871">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ChartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_128_14710"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <g clipPath="url(#clip0_128_14710)">
        <g opacity="0.4">
          <path
            d="M2.60946 22.9843C1.77292 22.9631 1.13928 22.4599 1.07089 21.6259C1.02993 21.1264 1 20.4398 1 19.5C1 18.5602 1.02993 17.8736 1.07089 17.3741C1.13928 16.5401 1.77292 16.0369 2.60946 16.0157C2.97545 16.0064 3.43306 16 4 16C4.56694 16 5.02455 16.0064 5.39055 16.0157C6.2271 16.0369 6.8607 16.5401 6.9291 17.3741C6.97005 17.8736 7 18.5602 7 19.5C7 20.4398 6.97005 21.1264 6.9291 21.6259C6.8607 22.4599 6.2271 22.9631 5.39055 22.9843C5.02455 22.9936 4.56694 23 4 23C3.43306 23 2.97545 22.9936 2.60946 22.9843Z"
            fill="#0c68e9"
          />
          <path
            d="M18.8455 22.9792C17.8709 22.9408 17.1875 22.2557 17.1243 21.2823C17.0588 20.2731 17 18.6337 17 16C17 13.3663 17.0588 11.727 17.1243 10.7177C17.1875 9.74435 17.8709 9.0592 18.8455 9.02075C19.1671 9.00805 19.549 9 20 9C20.451 9 20.8329 9.00805 21.1545 9.02075C22.1291 9.0592 22.8125 9.74435 22.8757 10.7177C22.9412 11.727 23 13.3663 23 16C23 18.6337 22.9412 20.2731 22.8757 21.2823C22.8125 22.2557 22.1291 22.9408 21.1545 22.9792C20.8329 22.992 20.451 23 20 23C19.549 23 19.1671 22.992 18.8455 22.9792Z"
            fill="#0c68e9"
          />
          <path
            d="M10.7766 22.9832C9.8427 22.9548 9.162 22.3419 9.0949 21.41C9.0422 20.6775 9 19.5936 9 18C9 16.4064 9.0422 15.3225 9.0949 14.59C9.162 13.6581 9.8427 13.0453 10.7766 13.0169C11.1122 13.0067 11.5163 13 12 13C12.4837 13 12.8878 13.0067 13.2234 13.0169C14.1573 13.0453 14.838 13.6581 14.9051 14.59C14.9578 15.3225 15 16.4064 15 18C15 19.5936 14.9578 20.6775 14.9051 21.41C14.838 22.3419 14.1573 22.9548 13.2234 22.9832C12.8878 22.9934 12.4837 23 12 23C11.5163 23 11.1122 22.9934 10.7766 22.9832Z"
            fill="#0c68e9"
          />
        </g>
        <path
          d="M20.9603 6.0506C20.9106 7.03855 19.9709 7.40975 19.242 6.741C18.9106 6.4369 18.5138 6.06255 18.0418 5.60285C16.9756 6.5731 15.322 8.08585 13.3506 9.91645C12.8329 10.3972 11.992 10.3435 11.5397 9.8007C10.6521 8.73875 9.75755 7.6807 8.8322 6.6514C7.7509 7.4453 5.81 8.95825 3.88389 10.8844C3.39573 11.3725 2.60427 11.3725 2.11612 10.8844C1.62796 10.3962 1.62796 9.60475 2.11612 9.1166C4.00573 7.227 6.079 5.4545 8.30255 3.96314L8.306 3.96082C8.8018 3.6303 9.46255 3.69527 9.8839 4.1166C10.8519 5.08455 11.7265 6.14925 12.6118 7.19265C14.1169 5.80065 15.3848 4.64087 16.274 3.8314C15.8705 3.41506 15.5362 3.06006 15.26 2.75898C14.591 2.02997 14.9624 1.08998 15.9506 1.04025C17.2115 0.976795 18.5055 0.939456 19.7511 1.17232C20.3119 1.27718 20.7233 1.68863 20.8281 2.24948C21.061 3.49521 21.0238 4.78949 20.9603 6.0506Z"
          fill="#0c68e9"
        />
      </g>
    </mask>
    <g mask="url(#mask0_128_14710)">
      <path d="M0 0H24V24H0V0Z" fill="#0c68e9" />
    </g>
    <defs>
      <clipPath id="clip0_128_14710">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const StepIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_55_893" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <g clipPath="url(#clip0_55_893)">
        <path
          opacity="0.4"
          d="M15.7798 4.5H5.2202C4.27169 4.5 3.5 5.06057 3.5 5.75042C3.5 6.43943 4.27169 7 5.2202 7H15.7798C16.7283 7 17.5 6.43943 17.5 5.75042C17.5 5.06054 16.7283 4.5 15.7798 4.5Z"
          fill="#1D7BF5"
        />
        <path
          d="M18.7798 10.75H8.2202C7.27169 10.75 6.5 11.3106 6.5 12.0004C6.5 12.6894 7.27169 13.25 8.2202 13.25H18.7798C19.7283 13.25 20.5 12.6894 20.5 12.0004C20.5 11.3105 19.7283 10.75 18.7798 10.75Z"
          fill="#1D7BF5"
        />
        <path
          d="M15.7798 17H5.2202C4.27169 17 3.5 17.5606 3.5 18.2504C3.5 18.9394 4.27169 19.5 5.2202 19.5H15.7798C16.7283 19.5 17.5 18.9394 17.5 18.2504C17.5 17.5606 16.7283 17 15.7798 17Z"
          fill="#1D7BF5"
        />
      </g>
    </mask>
    <g mask="url(#mask0_55_893)">
      <rect width="24" height="24" fill="#637381" />
    </g>
    <defs>
      <clipPath id="clip0_55_893">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const SettingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5506 21.5797C9.90153 21.7717 10.3687 21.8236 11.3019 21.9274C12.2351 22.0311 12.7013 22.083 13.0868 21.9729C13.5987 21.8264 14.0314 21.4825 14.2898 21.017C14.4079 20.8058 14.4725 20.5503 14.5293 20.1753C14.5663 19.9031 14.6721 19.6449 14.8367 19.425C15.0013 19.2051 15.2192 19.0308 15.4699 18.9186C15.7245 18.812 16.0019 18.7713 16.2764 18.8004C16.5509 18.8295 16.8136 18.9275 17.0402 19.0851C17.3564 19.2994 17.5891 19.4239 17.8261 19.4824C18.3446 19.61 18.8925 19.5277 19.3507 19.2535C19.6935 19.0481 19.9717 18.6726 20.527 17.9224C21.0833 17.1722 21.3604 16.7976 21.4568 16.4108C21.5845 15.8958 21.5001 15.3511 21.2227 14.8967C21.0968 14.6895 20.9069 14.5064 20.6082 14.2699C20.1669 13.9221 19.9187 13.3853 19.9804 12.8308C20.042 12.2762 20.4021 11.8071 20.9079 11.5655C21.2523 11.3996 21.4778 11.2626 21.6472 11.0883C21.8301 10.8994 21.9737 10.6761 22.0698 10.4314C22.166 10.1867 22.2126 9.92531 22.2072 9.66244C22.198 9.26499 22.0101 8.83761 21.6322 7.98361C21.2542 7.12961 21.0662 6.70322 20.777 6.42657C20.3913 6.05869 19.8743 5.85832 19.3399 5.86832C19.0958 5.87338 18.8415 5.94371 18.4859 6.08326C18.2301 6.18746 17.9521 6.22536 17.6778 6.19344C17.4034 6.16153 17.1415 6.06083 16.9165 5.9007C16.4644 5.5687 16.2351 5.02503 16.2759 4.46813C16.303 4.0888 16.2959 3.82641 16.2271 3.59439C16.0785 3.08485 15.732 2.65391 15.2635 2.39756C14.9126 2.2056 14.4454 2.15366 13.5122 2.04989C12.579 1.94611 12.1118 1.89417 11.7273 2.00435C11.2154 2.15089 10.7827 2.49473 10.5243 2.96025C10.4062 3.1715 10.3417 3.42593 10.2848 3.80194C10.2033 4.35431 9.85901 4.83522 9.34415 5.05868C9.08956 5.1653 8.81217 5.20594 8.53768 5.17682C8.2632 5.14771 8.00051 5.04979 7.77394 4.89213C7.45769 4.67787 7.22502 4.55339 6.98804 4.49484C6.46902 4.3667 5.9205 4.44959 5.4634 4.72375C5.1206 4.92913 4.8424 5.30468 4.28708 6.0549C3.73078 6.80502 3.45367 7.17969 3.35734 7.56641C3.29438 7.82174 3.28265 8.08702 3.32283 8.34692C3.36301 8.60681 3.45431 8.85616 3.59144 9.08056C3.71732 9.28774 3.90724 9.47085 4.20594 9.70731C4.64719 10.0552 4.8954 10.5919 4.83373 11.1465C4.77206 11.7011 4.41202 12.1702 3.90622 12.4117C3.56177 12.5777 3.33626 12.7146 3.16695 12.889C2.98404 13.0779 2.84037 13.3011 2.74425 13.5458C2.64813 13.7906 2.60147 14.0519 2.60695 14.3148C2.61608 14.7123 2.804 15.1396 3.18193 15.9936C3.55987 16.8476 3.7479 17.274 4.03709 17.5507C4.42384 17.9189 4.94032 18.1195 5.4742 18.1089C5.71825 18.1039 5.97258 18.0335 6.32819 17.894C6.58399 17.7898 6.86198 17.7519 7.13634 17.7838C7.4107 17.8157 7.67256 17.9164 7.89762 18.0766C8.11738 18.2412 8.29153 18.4591 8.40362 18.7098C8.51571 18.9605 8.56204 19.2356 8.53823 19.5091C8.51114 19.8885 8.51818 20.1508 8.58696 20.3829C8.6611 20.6359 8.78437 20.8718 8.94971 21.0771C9.11505 21.2825 9.31924 21.4533 9.5506 21.5797Z"
      fill="#637381"
    />
    <path
      d="M15.573 12.3079C15.573 13.9649 14.219 15.3079 12.55 15.3079C10.88 15.3079 9.52698 13.9649 9.52698 12.3079C9.52698 10.6509 10.88 9.30786 12.55 9.30786C14.22 9.30786 15.573 10.6509 15.573 12.3079Z"
      fill="#637381"
    />
  </svg>
);
export const ReportIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_128_14695"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <g clipPath="url(#clip0_128_14695)">
        <path
          opacity="0.4"
          d="M22 10.5C22 13.2057 21.9268 15.3258 21.8596 16.7017C21.8139 17.6384 20.9066 18.3109 19.9771 18.1857C18.4531 17.9803 15.8791 17.75 12 17.75C8.1209 17.75 5.54695 17.9803 4.02285 18.1857C3.09341 18.3109 2.18614 17.6384 2.14039 16.7017C2.07321 15.3258 2 13.2057 2 10.5C2 7.79427 2.07321 5.67417 2.14039 4.29829C2.18614 3.36156 3.09341 2.68909 4.02285 2.81433C5.54695 3.0197 8.1209 3.25002 12 3.25002C15.8791 3.25002 18.4531 3.0197 19.9771 2.81433C20.9066 2.68909 21.8139 3.36156 21.8596 4.29829C21.9268 5.67417 22 7.79427 22 10.5Z"
          fill="#0c68e9"
        />
        <path
          d="M5.59096 18.0096C5.28385 18.7424 4.94579 19.6105 4.65668 20.5C4.5685 20.7713 4.73269 21.0577 5.01662 21.0852C5.48092 21.1304 5.97612 21.1092 6.35562 21.0766C6.76872 21.0412 7.13172 20.805 7.35657 20.4566C7.94702 19.542 8.51881 18.5894 8.97868 17.8008C7.63073 17.8483 6.50815 17.9246 5.59096 18.0096Z"
          fill="#0c68e9"
        />
        <path
          d="M15.022 17.8008C15.4818 18.5894 16.0536 19.542 16.6441 20.4566C16.8689 20.805 17.2319 21.0412 17.645 21.0766C18.0245 21.1092 18.5197 21.1304 18.984 21.0852C19.268 21.0577 19.4321 20.7713 19.344 20.5C19.0549 19.6106 18.7168 18.7424 18.4097 18.0097C17.4925 17.9246 16.37 17.8484 15.022 17.8008Z"
          fill="#0c68e9"
        />
      </g>
    </mask>
    <g mask="url(#mask0_128_14695)">
      <rect width="24" height="24" fill="#0c68e9" />
    </g>
    <defs>
      <clipPath id="clip0_128_14695">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const DatabaseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 9C16.4183 9 20 7.65685 20 6C20 4.34315 16.4183 3 12 3C7.58172 3 4 4.34315 4 6C4 7.65685 7.58172 9 12 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 6V12C4 12.7956 4.84285 13.5587 6.34315 14.1213C7.84344 14.6839 9.87827 15 12 15C14.1217 15 16.1566 14.6839 17.6569 14.1213C19.1571 13.5587 20 12.7956 20 12V6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 12V18C4 18.7956 4.84285 19.5587 6.34315 20.1213C7.84344 20.6839 9.87827 21 12 21C14.1217 21 16.1566 20.6839 17.6569 20.1213C19.1571 19.5587 20 18.7956 20 18V12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UsersGroupIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 13C10 13.5304 10.2107 14.0391 10.5858 14.4142C10.9609 14.7893 11.4696 15 12 15C12.5304 15 13.0391 14.7893 13.4142 14.4142C13.7893 14.0391 14 13.5304 14 13C14 12.4696 13.7893 11.9609 13.4142 11.5858C13.0391 11.2107 12.5304 11 12 11C11.4696 11 10.9609 11.2107 10.5858 11.5858C10.2107 11.9609 10 12.4696 10 13Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 21V20C8 19.4696 8.21071 18.9609 8.58579 18.5858C8.96086 18.2107 9.46957 18 10 18H14C14.5304 18 15.0391 18.2107 15.4142 18.5858C15.7893 18.9609 16 19.4696 16 20V21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 5C15 5.53043 15.2107 6.03914 15.5858 6.41421C15.9609 6.78929 16.4696 7 17 7C17.5304 7 18.0391 6.78929 18.4142 6.41421C18.7893 6.03914 19 5.53043 19 5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3C16.4696 3 15.9609 3.21071 15.5858 3.58579C15.2107 3.96086 15 4.46957 15 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 10H19C19.5304 10 20.0391 10.2107 20.4142 10.5858C20.7893 10.9609 21 11.4696 21 12V13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5C5 5.53043 5.21071 6.03914 5.58579 6.41421C5.96086 6.78929 6.46957 7 7 7C7.53043 7 8.03914 6.78929 8.41421 6.41421C8.78929 6.03914 9 5.53043 9 5C9 4.46957 8.78929 3.96086 8.41421 3.58579C8.03914 3.21071 7.53043 3 7 3C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 13V12C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10H7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BlockQuoteIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 15H21" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 19H6" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 11H21" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 7H15" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M9 9H10C10.1978 9 10.3911 9.05865 10.5556 9.16853C10.72 9.27841 10.8482 9.43459 10.9239 9.61732C10.9996 9.80004 11.0194 10.0011 10.9808 10.1951C10.9422 10.3891 10.847 10.5673 10.7071 10.7071C10.5673 10.847 10.3891 10.9422 10.1951 10.9808C10.0011 11.0194 9.80004 10.9996 9.61732 10.9239C9.43459 10.8482 9.27841 10.72 9.16853 10.5556C9.05865 10.3911 9 10.1978 9 10V7.5C9 6.96957 9.21071 6.46086 9.58579 6.08579C9.96086 5.71071 10.4696 5.5 11 5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 9H4C4.19778 9 4.39112 9.05865 4.55557 9.16853C4.72002 9.27841 4.84819 9.43459 4.92388 9.61732C4.99957 9.80004 5.01937 10.0011 4.98079 10.1951C4.9422 10.3891 4.84696 10.5673 4.70711 10.7071C4.56725 10.847 4.38907 10.9422 4.19509 10.9808C4.00111 11.0194 3.80004 10.9996 3.61732 10.9239C3.43459 10.8482 3.27841 10.72 3.16853 10.5556C3.05865 10.3911 3 10.1978 3 10V7.5C3 6.96957 3.21071 6.46086 3.58579 6.08579C3.96086 5.71071 4.46957 5.5 5 5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LicenseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7957 3 18V17H13V19C13 19.5304 13.2107 20.0391 13.5858 20.4142C13.9609 20.7893 14.4696 21 15 21ZM15 21C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V5C17 4.60444 17.1173 4.21776 17.3371 3.88886C17.5568 3.55996 17.8692 3.30362 18.2346 3.15224C18.6001 3.00087 19.0022 2.96126 19.3902 3.03843C19.7781 3.1156 20.1345 3.30608 20.4142 3.58579C20.6939 3.86549 20.8844 4.22186 20.9616 4.60982C21.0387 4.99778 20.9991 5.39992 20.8478 5.76537C20.6964 6.13082 20.44 6.44318 20.1111 6.66294C19.7822 6.8827 19.3956 7 19 7H17M19 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9 7H13" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 11H13" stroke="#334155" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const ChartAreaLineIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 19L8 13L12 15L16 10L20 14V19H4Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 12L7 8L11 10L16 4L20 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BellIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M18.7499 9V9.704C18.7499 10.549 18.9899 11.375 19.4419 12.078L20.5499 13.801C21.5609 15.375 20.7889 17.514 19.0299 18.011C14.4337 19.3127 9.56623 19.3127 4.96994 18.011C3.21094 17.514 2.43894 15.375 3.44994 13.801L4.55794 12.078C5.01115 11.3692 5.25165 10.5453 5.25094 9.704V9C5.25094 5.134 8.27294 2 11.9999 2C15.7269 2 18.7499 5.134 18.7499 9Z"
      fill="#637381"
    />
    <path
      d="M12.75 6C12.75 5.80109 12.671 5.61032 12.5304 5.46967C12.3897 5.32902 12.199 5.25 12 5.25C11.8011 5.25 11.6104 5.32902 11.4697 5.46967C11.3291 5.61032 11.25 5.80109 11.25 6V10C11.25 10.1989 11.3291 10.3897 11.4697 10.5303C11.6104 10.671 11.8011 10.75 12 10.75C12.199 10.75 12.3897 10.671 12.5304 10.5303C12.671 10.3897 12.75 10.1989 12.75 10V6ZM7.24304 18.545C7.56979 19.5491 8.20593 20.4241 9.06034 21.0445C9.91475 21.665 10.9436 21.9992 11.9995 21.9992C13.0555 21.9992 14.0843 21.665 14.9387 21.0445C15.7932 20.4241 16.4293 19.5491 16.756 18.545C13.611 19.135 10.389 19.135 7.24304 18.545Z"
      fill="#637381"
    />
  </svg>
);
